// Ouste theme JS v2
(function(){
'use strict';

// Reveal on scroll
var io=new IntersectionObserver(function(es){
  es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);}});
},{threshold:.1,rootMargin:'0px 0px -6% 0px'});
document.querySelectorAll('.rv').forEach(function(el){io.observe(el);});
document.querySelectorAll('.hero .rv').forEach(function(el,i){setTimeout(function(){el.classList.add('in');},120+i*110);});

// FAQ accordion
document.querySelectorAll('.acc-q').forEach(function(q){
  q.addEventListener('click',function(){
    var it=q.parentElement,a=it.querySelector('.acc-a'),open=it.classList.contains('open');
    document.querySelectorAll('.acc-item').forEach(function(i){i.classList.remove('open');i.querySelector('.acc-a').style.maxHeight=null;});
    if(!open){it.classList.add('open');a.style.maxHeight=a.scrollHeight+'px';}
  });
});
var fo=document.querySelector('.acc-item.open .acc-a');
if(fo)fo.style.maxHeight=fo.scrollHeight+'px';

// Reviews slider
var rTrack=document.getElementById('rTrack');
if(rTrack){
  var rIdx=0;
  function rPerView(){return window.innerWidth<=760?1:window.innerWidth<=1040?2:3;}
  function rMaxIdx(){return Math.max(0,rTrack.children.length-rPerView());}
  function rGo(){
    if(!rTrack.children.length)return;
    var w=rTrack.children[0].getBoundingClientRect().width+20;
    rTrack.style.transform='translateX('+(-rIdx*w)+'px)';
  }
  var rNext=document.getElementById('rNext');
  var rPrev=document.getElementById('rPrev');
  if(rNext)rNext.onclick=function(){rIdx=Math.min(rMaxIdx(),rIdx+1);rGo();};
  if(rPrev)rPrev.onclick=function(){rIdx=Math.max(0,rIdx-1);rGo();};
  window.addEventListener('resize',function(){rIdx=Math.min(rIdx,rMaxIdx());rGo();});
}

// Night slider — barre de progression animée
var nSlider=document.getElementById('nSlider');
if(nSlider){
  var nSlides=nSlider.querySelectorAll('.nslide');
  var nFill=document.getElementById('nFill');
  var nCur=document.getElementById('nCur');
  var nIdx=0,nTimer=null;

  function nStartBar(){
    if(!nFill)return;
    nFill.style.transition='none';
    nFill.style.width='0%';
    void nFill.offsetWidth;
    nFill.style.transition='width 4s linear';
    nFill.style.width='100%';
  }

  function nGo(i){
    nSlides[nIdx].classList.remove('active');
    nIdx=(i+nSlides.length)%nSlides.length;
    nSlides[nIdx].classList.add('active');
    if(nCur)nCur.textContent=nIdx+1;
    nStartBar();
  }

  function nAuto(){
    clearTimeout(nTimer);
    nTimer=setTimeout(function(){nGo(nIdx+1);nAuto();},4000);
  }

  var nPrev=document.getElementById('nPrev');
  var nNext2=document.getElementById('nNext');
  if(nPrev)nPrev.onclick=function(){clearTimeout(nTimer);nGo(nIdx-1);nAuto();};
  if(nNext2)nNext2.onclick=function(){clearTimeout(nTimer);nGo(nIdx+1);nAuto();};

  nStartBar();
  nAuto();
}

// Mobile drawer
var burger=document.getElementById('ouste-burger');
var drawer=document.getElementById('ouste-drawer');
var drawerOv=document.getElementById('ouste-drawer-ov');
var drawerClose=document.getElementById('ouste-drawer-close');
function openDrawer(){if(drawer)drawer.classList.add('show');if(drawerOv)drawerOv.classList.add('show');document.body.style.overflow='hidden';}
function closeDrawer(){if(drawer)drawer.classList.remove('show');if(drawerOv)drawerOv.classList.remove('show');document.body.style.overflow='';}
if(burger)burger.onclick=openDrawer;
if(drawerClose)drawerClose.onclick=closeDrawer;
if(drawerOv)drawerOv.onclick=closeDrawer;
document.querySelectorAll('.ouste-drawer-links a,.dcard').forEach(function(a){a.addEventListener('click',closeDrawer);});

// Scroll popup
var popOv=document.getElementById('popOv');
var popClose=document.getElementById('popClose');
var _ps=false;
if(popOv&&!sessionStorage.getItem('ou_p')){
  window.addEventListener('scroll',function(){
    if(!_ps&&window.scrollY>600){
      _ps=true;sessionStorage.setItem('ou_p','1');
      setTimeout(function(){popOv.classList.add('show');},400);
    }
  },{passive:true});
  if(popClose)popClose.onclick=function(){popOv.classList.remove('show');};
  popOv.onclick=function(e){if(e.target===popOv)popOv.classList.remove('show');};
  var pBtn=document.getElementById('popShop');
  if(pBtn)pBtn.onclick=function(){popOv.classList.remove('show');};
}

// Copy code
document.querySelectorAll('.copy-btn,#ctaCopy').forEach(function(btn){
  btn.addEventListener('click',function(){
    var box=btn.closest('.code-row,.cta-code');
    var el=box?box.querySelector('.code-box,.cta-codepill b,b'):null;
    var txt=el?el.textContent.trim():'PRINTOUSTE10';
    if(navigator.clipboard)navigator.clipboard.writeText(txt).catch(function(){});
    btn.classList.add('done');
    setTimeout(function(){btn.classList.remove('done');},2200);
  });
});

// Sticky cart
var sc=document.getElementById('stickyCart');
if(sc)window.addEventListener('scroll',function(){sc.classList.toggle('show',window.scrollY>400);},{passive:true});

})();
